import React from 'react';
import { GiftIcon, ImageIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-ink px-5 py-20 text-white sm:px-8" data-id="element-17" data-mp="plsjs38jiy8p">
      <div className="mx-auto w-full max-w-6xl" data-id="element-18" data-mp="aujww1w0vqz9">
        <Reveal data-id="element-19" data-mp="ftmtqz1umqw5">
          <h2 className="flex flex-wrap items-center justify-center gap-3 text-center font-display text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-20" data-mp="ftejlex41zon">
            <GiftIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-21" data-mp="1wrjj39v2tei" />
            <span data-id="element-22" data-mp="5xjrzuawsu9q">
              You Also Get <span className="text-cheer" data-id="element-23" data-mp="3o1le8odmbfhv">5 Strategic Bonuses</span>
            </span>
          </h2>
          <p className="mt-4 text-center text-sm font-semibold uppercase tracking-widest text-gold" data-id="element-24" data-mp="3t0okud98xtry">
            Real value: $87 — today: Free
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="1mb1o9nkrj3f1">
          {bonuses.map((bonus, index) => <Reveal key={bonus.tag} delay={index % 3 * 0.05} className="h-full" data-id="element-26" data-mp="1r6yyrd9chfjw" data-mpi={index}>
              <article className="flex h-full flex-col overflow-hidden rounded-card border border-cheer/40 bg-[#121218] transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-27" data-mp="3icbv1xinnzoy">
                <div className="flex aspect-[4/3] w-full flex-col items-center justify-center gap-2 border-b border-cheer/20 bg-[#17171f]" role="img" aria-label={`${bonus.title} mockup placeholder`} data-id="element-28" data-mp="3r5ynperkgmtx">
                  <ImageIcon className="h-7 w-7 text-cheer/70" aria-hidden="true" data-id="element-29" data-mp="2uhivfax2nzd4" />
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-white/40" data-id="element-30" data-mp="38gs3fnb4jn60">
                    {bonus.placeholderLabel}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-31" data-mp="npi30a633srl">
                  <span className="w-fit rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-navy" data-id="element-32" data-mp="ns49e6h8o288">
                    {bonus.tag}
                  </span>
                  <h3 className="mt-3 font-display text-base font-extrabold leading-snug" data-id="element-33" data-mp="3cin1723yzcdg">
                    {bonus.title}
                  </h3>
                  <p className="mt-auto pt-2 text-sm leading-relaxed text-white/60" data-id="element-34" data-mp="3lj32q615k9fo">
                    {bonus.description}
                  </p>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}